export const copy = {
  en: {
    steps: ['Item', 'Place', 'Proof', 'Contact', 'Summary'],
    optional: 'optional',
    common: {
      back: 'Back',
      continue: 'Continue',
      unknown: "I don't know",
      required: 'Required',
      retry: 'Try again',
    },
    intake: {
      title: 'Tell us what went missing',
      lead: 'In one sentence, say what went missing, when, and where. It should take less than a minute.',
      completedTitle: 'Review what we understood',
      completedLead:
        'Correct anything below, then continue. You do not need to describe the item again.',
      voice: 'Tell us what went missing',
      listening: 'Listening...',
      connecting: 'Connecting securely...',
      thinking: 'Structuring your report...',
      textLink: 'I prefer to type',
      textLabel: 'Describe the lost item',
      textPlaceholder: 'For example: black wallet, yesterday evening in the hotel lobby',
      parse: 'Structure my description',
      restart: 'Restart the conversation',
      micDenied: 'Microphone access is unavailable. You can complete the same report by typing.',
      unavailable: 'Voice is temporarily unavailable. Your entered data has not been lost.',
      privacy:
        'Audio is not stored. OpenAI may retain data for up to 30 days for abuse monitoring.',
      heard: 'We understood',
      startOver: 'Start over',
      item: 'Item',
      when: 'When',
      where: 'Where',
      future: 'The date cannot be in the future. Correct it or choose “I don’t know”.',
    },
    place: {
      title: 'Where did the item go missing?',
      lead: 'The invitation venue is already selected. Change it only if the loss happened elsewhere.',
      venue: 'At this venue',
      different: 'Somewhere else',
      unknown: "I don't remember the place",
      search: 'Search for a place',
      context: 'Add context, such as lobby, room 412, or platform',
      freeform: 'Place name or description',
    },
    proof: {
      title: 'How can the item be recognized?',
      lead: 'Add a private identifying detail or photo. This step is optional.',
      description: 'Proof description',
      placeholder: 'For example: a worn corner or a sticker under the case',
      photo: 'Add a private photo',
      photoHint: 'JPG, PNG, HEIC or WebP, up to 10 MB. Metadata will be removed.',
      wallet:
        'Refindi does not mediate the transfer of cash. The wallet itself should be handed to venue staff and its contents may be deposited under the venue procedure.',
      secrets: 'Do not enter a PIN, CVV, password, full card number, or unlock pattern.',
    },
    contact: {
      title: 'How can we contact you?',
      lead: 'Your details are available only to authorized Refindi staff for 30 days.',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone, optional',
      preferred: 'Preferred contact',
      emailChannel: 'Email',
      phoneChannel: 'Phone',
      tos: 'I accept the Refindi terms.',
      privacy: 'I have read the privacy notice, including OpenAI processing.',
      suggestion: 'Did you mean',
    },
    summary: {
      title: 'Review your report',
      lead: 'Make sure the information is correct before submitting.',
      submit: 'Submit report',
      submitting: 'Submitting securely...',
      item: 'Item',
      date: 'Date',
      place: 'Place',
      proof: 'Proof',
      contact: 'Contact',
      edit: 'Edit',
    },
    confirmed: {
      title: 'Your report has been received',
      lead: 'Use your secure tracking link to follow the review and provide shipping or pickup instructions when a match is found.',
      reference: 'Report reference',
      openTracking: 'Open tracking',
      copyTracking: 'Copy tracking link',
      emailFailed: 'We could not send the confirmation email. Save the secure tracking link now.',
      another: 'Report another item',
      close: 'We also send the tracking link to your email when delivery is available.',
    },
  },
} as const;

export type Language = 'en';
